import { render, staticRenderFns } from "./CreateInvoice.vue?vue&type=template&id=618d7820&"
import script from "./CreateInvoice.vue?vue&type=script&lang=js&"
export * from "./CreateInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports